import Error from 'components/error'
import { useEffect, useState } from 'react'
import { amplitudeEvent } from 'lib/amplitude'
import { useAuth } from 'lib/auth'
import {
  flags,
  useFeatureFlags,
  useFeatureFlagsLoading,
} from 'lib/feature-flags'
import LeadForm from '../../coach-leads/lead-form'
import SelectTimeLayout from './select-time-layout'
import SelectTimeLayoutRedesign from './redesign/select-time-layout-redesign'
import SelectTimeSkeleton from './select-time-skeleton'
import SelectTimeSkeletonRedesign from './redesign/select-time-skeleton-redesign'
import { useMonthlyLessonAvailability } from './utils'

const SelectLessonTime = ({
  currentUrl,
  previousUrl,
  locationId,
  lessonTypeId,
  lessonCreditBalanceQuantity,
  nextExpirationDate,
}) => {
  const { data, loading, error, refetch } = useMonthlyLessonAvailability(
    locationId,
    lessonTypeId,
    true,
  )
  const [showRequestTime, setShowRequestTime] = useState(false)
  const { isLoggedIn } = useAuth()
  const [redesignEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_PRIVATE_BOOKING_REDESIGN,
  ])
  // Flags are evaluated anonymously first, then again after sign-in. Wait for
  // the signed-in value so flag-on users do not see the old layout flash.
  const flagsLoading = useFeatureFlagsLoading()

  useEffect(() => {
    amplitudeEvent('start-private-booking', {
      is_guest: !isLoggedIn,
      guest_booking_enabled: true,
      lesson_type_id: lessonTypeId,
      location_id: locationId,
    })
    // fire once per page view
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) return <Error error={error} />
  if (loading || flagsLoading) {
    // The redesign loads into a skeleton that mirrors its own layout. While
    // flags are still being evaluated and read off we cannot tell flag-off
    // from flag-on yet, so flag-off keeps its existing skeleton.
    return redesignEnabled ? (
      <SelectTimeSkeletonRedesign />
    ) : (
      <SelectTimeSkeleton />
    )
  }

  const { lessonTypes } = data
  const coach = lessonTypes[0].coach

  if (showRequestTime) {
    return <LeadForm coach={coach} source="MYPGA_SCHEDULE_FULLY_BOOKED" />
  }

  const Layout = redesignEnabled ? SelectTimeLayoutRedesign : SelectTimeLayout

  return (
    <Layout
      lessonTypes={lessonTypes}
      currentUrl={currentUrl}
      previousUrl={previousUrl}
      refetch={refetch}
      setShowRequestTime={coach.coachProfile ? setShowRequestTime : false}
      lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
      nextExpirationDate={nextExpirationDate}
    />
  )
}

export default SelectLessonTime
